import styled from 'styled-components';
import Button from 'components/Button';
import { th } from 'style/theme';
import { sizes } from 'style';

export const StepImages = styled.div`
  position: relative;
  display: flex;
  margin-bottom: 20px;
`;

export const StepImage = styled.div`
  align-self: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  padding: 10px;
  border-radius: 50%;
  background-color: ${th('colors.dew')};

  @media ${sizes.desktop} {
    width: 80px;
    height: 80px;
  }

  > img {
    width: 80%;
    height: auto;
  }

  :last-child {
    width: 55px;
    height: 55px;
    background-color: ${th('colors.galleryGray')};

    @media ${sizes.desktop} {
      width: 70px;
      height: 70px;
    }

    > img {
      opacity: 0.5;
    }
  }
`;

export const Divider = styled.div`
  align-self: center;
  width: 30px;
  height: 1px;
  background-color: ${th('colors.turquoise')};

  @media ${sizes.desktop} {
    width: 40px;
  }
`;

export const DividerGray = styled(Divider)`
  background-color: #d9d9d9;
`;

export const NextButton = styled(Button)`
  margin-top: 12px;
`;

export const NPSContainer = styled.div`
  margin-top: 40px;
`;
